import React from 'react'
import Modal from 'react-bootstrap/lib/Modal'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'

/* Components */
import ScheduleForm from './ExpSchedule/ScheduleForm'
/* Actions */
import * as modalActionCreators from '../../actions/modals'

const ReceiptModal = props => {
  const { show, modalActions, item } = props
  return (
    <Modal
      show={show}
      onHide={() => modalActions.hideScheduleFormModal()}
      animation={false}
      bsSize="large"
      className="receipt-modal"
    >
      <Modal.Header closeButton className="customHeader">
        <h5>Add/Edit Schedule</h5>
      </Modal.Header>
      <Modal.Body>
        <ScheduleForm {...props} />
      </Modal.Body>
    </Modal>
  )
}

ReceiptModal.propTypes = {
  modalActions: PropTypes.shape({}).isRequired,
  show: PropTypes.bool.isRequired
}
const mapStateToProps = state => ({
  currentUser: state.reduxTokenAuth.currentUser
})

const mapDispatchToProps = dispatch => ({
  modalActions: bindActionCreators(modalActionCreators, dispatch)
})
export default connect(mapStateToProps, mapDispatchToProps)(ReceiptModal)
